export const config = {
  inputFieldsSelector: '.js-input',
  errorLabelSelector: '.email-not-found--error',
  inputTypePhone: '.js-phone',
  validationClasses: {
    error: 'a-input__input--error',
    valid: 'valid',
    container: '.a-input__input--error',
    numberField: 'js-number-error',
    emailField: 'js-email-error',
    phoneField: 'js-phone-error',
    passwordField: 'js-pass-error',
    textField: 'js-text-error',
  },
  regexExp: {
    email:
      /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    phone: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
  },
  validTelKeys: [
    'Backspace',
    'Delete',
    'ArrowRight',
    'ArrowUp',
    'ArrowLeft',
    'ArrowDown',
    'Enter',
    'Tab',
    ' ',
    ')',
    '(',
    '/',
    '+',
    '-',
    '.',
  ],
  validNumKeys: ['Backspace', 'Delete', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'ArrowDown', 'Enter', 'Tab', ''],
};
